import {SocialIcon} from "../components/social-icons/SocialIcons";

const flexportSocialData: Array<SocialIcon> = [
  {
    icon: "facebook",
    url: "https://facebook.com/flexport",
  },
  {
    icon: "twitter",
    url: "https://twitter.com/flexport",
  },
  {
    icon: "linkedin",
    url: "https://www.linkedin.com/company/flexport/",
  },
];

export default flexportSocialData;
